import ExploreLinks from "@/components/marketing/ExploreLinks";
import SEOHead from "@/components/SEOHead";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import FloatingBookButton from "@/components/layout/FloatingBookButton";
import HeroSection from "@/components/home/HeroSection";

import HighlightBadgesSection from "@/components/home/HighlightBadgesSection";
import VideoSection from "@/components/home/VideoSection";
import ExperienceOptionsSection from "@/components/home/ExperienceOptionsSection";
import RiverHighlightSection from "@/components/home/RiverHighlightSection";
import WhyChooseUsSection from "@/components/home/WhyChooseUsSection";
import TestimonialsSection from "@/components/home/TestimonialsSection";
import GuestsMentionMost from "@/components/home/GuestsMentionMost";
import PhotoGallerySection from "@/components/home/PhotoGallerySection";
import LocationSection from "@/components/home/LocationSection";
import EmailCaptureSection from "@/components/home/EmailCaptureSection";
import FinalCTASection from "@/components/home/FinalCTASection";
import SEOContentBlock from "@/components/seo/SEOContentBlock";
import DriveTimesSection from "@/components/seo/DriveTimesSection";
import SonsGetawaysCluster from "@/components/seo/SonsGetawaysCluster";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="San Marcos River Glamping & Tubing | Son's Blue River"
        description="San Marcos River glamping, AC cabins, on-site tubing & kayaking in Kingsbury, TX. Family-friendly — 45 min from Austin, 50 min from San Antonio."
        canonicalUrl="https://bluerivercamp.com/"
        ogImage="https://bluerivercamp.com/og-image.png"
        schemaJson={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Son's Blue River Camp",
            "alternateName": "Son's Blue River Camp – San Marcos River take-out",
            "url": "https://bluerivercamp.com",
            "logo": "https://bluerivercamp.com/favicon.png",
            "sameAs": [
              "https://www.facebook.com/sonsbluerivercamp",
              "https://www.instagram.com/sonsbluerivercamp"
            ]
          },
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "Son's Blue River Camp",
            "url": "https://bluerivercamp.com",
            "potentialAction": {
              "@type": "SearchAction",
              "target": "https://bluerivercamp.com/?q={search_term_string}",
              "query-input": "required name=search_term_string"
            }
          },
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Son's Blue River Camp",
            "alternateName": "Son's Blue River Camp – San Marcos River take-out",
            "description": "Family-friendly stretch of the spring-fed San Marcos River — glamping cabins, riverside cabanas, tubing & kayaking on 8 private acres in Kingsbury, TX. Not the Comal/Guadalupe party scene.",
            "url": "https://bluerivercamp.com",
            "telephone": "+18775777667",
            "image": "https://bluerivercamp.com/og-image.png",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "2769 Sherrill Rd",
              "addressLocality": "Kingsbury",
              "addressRegion": "TX",
              "postalCode": "78638",
              "addressCountry": "US"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 29.72751,
              "longitude": -97.76306
            },
            "priceRange": "$$",
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.5",
              "reviewCount": "1420",
              "bestRating": "5",
              "worstRating": "1"
            },
            "openingHoursSpecification": {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
              "opens": "08:00",
              "closes": "22:00"
            },
            "sameAs": [
              "https://www.facebook.com/sonsbluerivercamp",
              "https://www.instagram.com/sonsbluerivercamp",
              "https://sonsriverranch.com",
              "https://sonsgetaways.com"
            ]
          },
          {
            "@context": "https://schema.org",
            "@type": "Campground",
            "name": "Son's Blue River Camp",
            "alternateName": "San Marcos River Campground",
            "description": "Campground on the spring-fed San Marcos River in Kingsbury, TX with air-conditioned glamping cabins, log cabins, tent camping, riverfront cabanas, and on-site tubing and kayaking. The take-out for the San Marcos float; sister property Son's River Ranch is the put-in.",
            "url": "https://bluerivercamp.com",
            "telephone": "+18775777667",
            "image": "https://bluerivercamp.com/og-image.png",
            "priceRange": "$$",
            "petsAllowed": false,
            "checkinTime": "15:00",
            "checkoutTime": "11:00",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "2769 Sherrill Rd",
              "addressLocality": "Kingsbury",
              "addressRegion": "TX",
              "postalCode": "78638",
              "addressCountry": "US"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 29.72751,
              "longitude": -97.76306
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.5",
              "reviewCount": "1420",
              "bestRating": "5",
              "worstRating": "1"
            },
            "amenityFeature": [
              { "@type": "LocationFeatureSpecification", "name": "Air-Conditioned Glamping", "value": true },
              { "@type": "LocationFeatureSpecification", "name": "On-Site Tubing", "value": true },
              { "@type": "LocationFeatureSpecification", "name": "On-Site Kayaking", "value": true },
              { "@type": "LocationFeatureSpecification", "name": "Riverfront Cabanas", "value": true },
              { "@type": "LocationFeatureSpecification", "name": "Log Cabins", "value": true },
              { "@type": "LocationFeatureSpecification", "name": "Tent Sites", "value": true },
              { "@type": "LocationFeatureSpecification", "name": "Pavilion Space", "value": true },
              { "@type": "LocationFeatureSpecification", "name": "Group Cabana", "value": true },
              { "@type": "LocationFeatureSpecification", "name": "Bathhouse & Showers", "value": true },
              { "@type": "LocationFeatureSpecification", "name": "Family-Friendly (Capped Day Passes)", "value": true }
            ]
          },
          {
            "@context": "https://schema.org",
            "@type": "LodgingBusiness",
            "@id": "https://sonsriverranch.com#sister",
            "name": "Son's River Ranch",
            "url": "https://sonsriverranch.com",
            "description": "Sister property on the San Marcos River — the put-in for the float that takes out at Son's Blue River Camp."
          },
          {
            "@context": "https://schema.org",
            "@type": "TouristAttraction",
            "name": "Son's Blue River Camp",
            "description": "8 private acres on a family-friendly, spring-fed stretch of the San Marcos River — glamping cabins, riverside cabanas, tubing and kayaking. A quieter alternative to the Comal and Guadalupe party rivers.",
            "url": "https://bluerivercamp.com",
            "touristType": ["Families", "Couples", "Groups"],
            "isAccessibleForFree": false
          },
          {
            "@context": "https://schema.org",
            "@type": "Resort",
            "name": "Son's Blue River Camp",
            "url": "https://bluerivercamp.com",
            "telephone": "+18775777667",
            "priceRange": "$$",
            "petsAllowed": false,
            "checkinTime": "15:00",
            "checkoutTime": "11:00",
            "amenityFeature": [
              { "@type": "LocationFeatureSpecification", "name": "Glamping Cabins", "value": true },
              { "@type": "LocationFeatureSpecification", "name": "Log Cabins", "value": true },
              { "@type": "LocationFeatureSpecification", "name": "Tent Camping", "value": true },
              { "@type": "LocationFeatureSpecification", "name": "Tubing", "value": true },
              { "@type": "LocationFeatureSpecification", "name": "Kayaking", "value": true },
              { "@type": "LocationFeatureSpecification", "name": "Riverfront Cabanas", "value": true },
              { "@type": "LocationFeatureSpecification", "name": "Family-Friendly", "value": true },
              { "@type": "LocationFeatureSpecification", "name": "Pet-Free", "value": true },
              { "@type": "LocationFeatureSpecification", "name": "Air Conditioning", "value": true },
              { "@type": "LocationFeatureSpecification", "name": "Free Parking", "value": true }
            ]
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://bluerivercamp.com/" }
            ]
          },
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "Is Son's Blue River Camp the same as the Comal or Guadalupe tubing scene?",
                "acceptedAnswer": { "@type": "Answer", "text": "No. We're on a family-friendly stretch of the spring-fed San Marcos River in Kingsbury, TX — not the Comal or Guadalupe party rivers. We cap day-pass numbers, don't allow public outfitter drop-offs, and the property is 8 private acres rather than open public access." }
              },
              {
                "@type": "Question",
                "name": "How far is Son's Blue River Camp from Austin, San Antonio, and Houston?",
                "acceptedAnswer": { "@type": "Answer", "text": "About 45 minutes from Austin and 50 minutes from San Antonio, 20 minutes from New Braunfels, and roughly 2.5 hours from Houston." }
              },
              {
                "@type": "Question",
                "name": "What's included with a riverfront cabana?",
                "acceptedAnswer": { "@type": "Answer", "text": "Each cabana includes a covered shaded structure, picnic table, parking, restroom and bathhouse access, entry for up to 8 guests." }
              },
              {
                "@type": "Question",
                "name": "Are pets allowed at Son's Blue River Camp?",
                "acceptedAnswer": { "@type": "Answer", "text": "Son's Blue River Camp is pet-free to keep the property quiet and family-friendly. Service animals are welcome." }
              },
              {
                "@type": "Question",
                "name": "Is the San Marcos River safe for kids?",
                "acceptedAnswer": { "@type": "Answer", "text": "Yes. Our 1.5-mile stretch is gentle, spring-fed, and shaded by cypress trees — well suited to families, first-time floaters, and kids in life jackets. Children should be supervised at all times." }
              }
            ]
          }
        ]}
      />
      <Header />
      <main>
        <HeroSection />
        <HighlightBadgesSection />
        
        <ExperienceOptionsSection />
        <RiverHighlightSection />
        <WhyChooseUsSection />
        <GuestsMentionMost />
        <TestimonialsSection />
        <VideoSection videoId="c8ocZMTrneA" />
        <PhotoGallerySection />
        <VideoSection videoId="Ry72QJbX1ic" />
        <LocationSection />
        <FinalCTASection />
        <EmailCaptureSection />
        <SEOContentBlock
          heading="Family Glamping, Tubing & Cabins on the San Marcos River"
          paragraphs={[
            "Son's Blue River Camp is a family-owned, 8-acre <strong>riverfront resort on a family-friendly stretch of the spring-fed San Marcos River</strong> in Kingsbury, TX — just 45 minutes from Austin and 50 minutes from San Antonio, and about 2.5 hours from Houston. We're intentionally not the Comal or Guadalupe party scene: day-pass numbers are capped, no public outfitter drop-offs, and the property stays quiet enough for families, kids, and multi-gen trips.",
            "Whether you're after <strong>glamping cabins</strong>, riverside cabanas, log cabins, or budget-friendly tent camping, every stay puts you steps from a spring-fed river with <strong>unlimited tubing and kayaking</strong>. Lounge in a private cabana, grill at a riverfront picnic table, then wind down around the fire pit with clean bathhouses and a cypress-lined shoreline — the easiest <strong>Texas Hill Country getaway</strong> you'll find.",
          ]}
          keywords={[
            "San Marcos River glamping",
            "river cabins near Austin",
            "Texas Hill Country tubing",
            "family-friendly campground",
            "riverside cabanas",
            "spring-fed river Texas",
            "kayaking near San Antonio",
            "weekend getaway from Houston",
          ]}
          ctaHref="/book-now"
          ctaLabel="Book Your River Getaway"
        />
        <DriveTimesSection />
        <SonsGetawaysCluster />
      </main>
      <ExploreLinks links={["/cabana-rentals","/cabins","/day-passes","/day-trip"]} />
      <Footer />
    </div>
  );
};

export default Index;
